import { render, staticRenderFns } from "./hanjieyuegzb.vue?vue&type=template&id=498b2046&scoped=true&"
import script from "./hanjieyuegzb.vue?vue&type=script&lang=js&"
export * from "./hanjieyuegzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b2046",
  null
  
)

export default component.exports